import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Divider from '@mui/material/Divider';
import { TextField, Button, MenuItem } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        marginBottom: 10,
        marginTop: 10
    },
    item: {
        display: 'flex',
        flexDirection: 'column',
        marginRight: 10,
    },
    resize: {
        padding: 10
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
        width: '15%',
        marginTop: 29,
        textAlign: "center"
    },
    label: {
        textAlign: 'left',
        font: 'bold 14px Lato',
        letterSpacing: 0,
        color: '#174A84',
        opacity: 1,
        marginTop: 5,
        marginBottom: 5,
        inlineSize: 'max-content'
    },
    button: {
        textTransform: 'capitalize',
        backgroundColor: '#174A84',
        fontSize: 14
    }
}));

const ReportsFilter = props => {
    const classes = useStyles();
    const { values, onHandleChange, getData, onClearFilters, isLoading } = props;
    return (
        <Fragment>
            <div className={classes.container}>
                <div className={classes.item} style={{
                    width: '20%'
                }}>
                    <span className={classes.label}>Courses</span>
                    <TextField
                        placeholder="Course"
                        variant="outlined"
                        name="courseId"
                        id="courseId"
                        InputProps={{ classes: { input: classes.resize } }}
                        value={values.courseId}
                        onChange={e => {
                            onHandleChange(e);
                        }}
                        select
                    >
                        <MenuItem value={0}>
                            All
                        </MenuItem>
                        {values.coursesData.map(item => {
                            return (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.label}
                                </MenuItem>
                            );
                        })}
                    </TextField>
                </div>
                <div className={classes.actions}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        disabled={isLoading}
                        onClick={() => getData()}
                        style={{ width: "48%" }}
                    >
                        {isLoading ?
                            <CircularProgress
                                style={{
                                    color: 'white'
                                }}
                                size={24}
                            />
                            :
                            "Search"
                        }
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        style={{
                            marginLeft: "4%",
                            width: "48%"
                        }}
                        onClick={() => onClearFilters()}
                    >Clear</Button>
                </div>
            </div>
            <Divider style={{
                backgroundColor: 'rgb(58, 127, 187)',
                opacity: '0.3',
            }} />

        </Fragment>
    );
}

ReportsFilter.defaultProps = {
    onHandleChange: fn => fn,
    getData: fn => fn,
    values: {},
    onClearFilters: fn => fn,
    handleDateChange: fn => fn,
    isLoading: false
};

ReportsFilter.propTypes = {
    onHandleChange: PropTypes.func,
    values: PropTypes.object,
    getData: PropTypes.func,
    onClearFilters: PropTypes.func,
    handleDateChange: PropTypes.func,
    isLoading: PropTypes.bool,
};

export default ReportsFilter;